/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import TextField from 'components/Form/TextField';
import CheckBox from "components/Form/CheckBox";
import Colors from "constants/Colors";
import TagsList3 from "components/TagList3";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ButtonContent, Footer, Scrollbox, Title } from './styles';
import InputField from 'components/Form/InputField';
import { LostCancelButton } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import { Label } from "components/Form";
import Loader from 'components/Loader/index';
import HasPermission from 'components/HasPermission/index';

export default function SendPolicyPackClient(props) {

  const loading = useContext(GlobalLoaderContext);
  const [summary, setSummary] = useState({});
  const [insurers, setInsurers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [wordingFile, setWordingFile] = useState({});
  const [file, setFile] = useState();
  const [endorsmentType, setEndorsmentType] = useState("");
  const [wordingAttachmentFile, setWordingAttachmentFile] = useState({});
  const [isBound, setIsBound] = useState(false);
  const [idProduct, setIdProduct] = useState(null);

  const formik = useRef(null);
  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate} ${message.approvalComments} `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleFile() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestPolicyDocument(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        } else {
          setFile(response.ret_value.policePackReturnDocs);
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
      });;

  };

  function handleSummary() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });

        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType);

        if (formik.current) {
          formik.current?.setFieldValue('policyPackMessage', data.ret_value.policyPackMessage || '');
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
      });
  };

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.enablePolicySend(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      if (res.ret_value.attachments) {
        setAttachments(res.ret_value.attachments)
      }
    })
  }

  function handleSelect(insurer) {
    const contact = { idContact: insurer.idContact, email: insurer.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === insurer.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== insurer.email);
      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, contact]);
    };
  };

  function listContacts(idContactDepartment) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestListContactsByType(props.match.params.idOperationRoot || props.match.params.idOperation, 'client', idContactDepartment)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          loading.stop();
          return;
        }
        setInsurers(data.ret_value);
        loading.stop();
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        loading.stop();
      });
  };

  async function handleGetFiles() {
    loading.start();

    fitinsur.requestGetDocuments(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
      });


    fitinsur.requestGetDocuments(props.match.params.idOperation, true)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingAttachmentFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument,
          });
        } else {
          setWordingAttachmentFile({})
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${fitinsur.requestGetDocuments.name}\n` + error);
      });

    fitinsur.requestAttachAssumptions(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        console.log("Resposta Attachments", response);
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });

    loading.stop();
  }

  async function handleOperationInfo() {
    loading.start()
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setIsBound(response?.isBound);
        setIdProduct(response?.isDeclaration ? response?.idProduct : 12);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
        loading.stop();
      });
  }

  useEffect(() => { 
    if(idProduct == 12) { 
      history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`)
    } else if(idProduct == 16) { 
      history.push(`/broking/send-approval-pack-declaration/${props.match.params.idOperation}`)
    }
  }, [idProduct])

  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)
    }
  }, [historymsg])

  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    handleGetFiles();
    handleFile();
    handleSummary();
    listContacts();
    handleEnable();
    handleOperationInfo();
  }, []);


  const listItems = insurers.length ? insurers.map((contact) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px", marginBottom: '5px' }} key={contact.idContact}>
        <Col md={4} style={{ flexDirection: "row", display: "flex" }}>
          <label>
            <CheckBox
              onChange={() => { handleSelect(contact) }}
              checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
              disabled={isBound ? true : contact.existContact ? true : false}
            />
          </label>
          {contact.legalEntity}
        </Col>
        <Col md={3}>
          <Label textColor={contact?.existContact ? Colors.GRAY[3] : null}>
            {contact.nameContact}
          </Label>
        </Col>
        <Col md={2}>
          <Label textColor={contact?.existContact ? Colors.GRAY[3] : null}>
            {contact.personContactDepartment}
          </Label>
        </Col>
        <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label textColor={contact?.existContact ? Colors.GRAY[3] : null}>{contact.email}</Label>
        </Col>
      </Row>
    </>
  )) :
    (<Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>)
    ;

  const handleSubmit = (e) => {
    if (selectedItems.length == 0) {
      mc.error('Please, select at least one contact');
      return;
    }
    let body = {
      idOperation: props.match.params.idOperation,
      contacts: [...selectedItems],
      cc: e.cc
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.sendPolicyPack(body)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          return;
        }
        if (endorsmentType && endorsmentType !== "declaration") {
          return history.push('/policies');
        } else {
          return history.push('/list');
        }
      });
  }

  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary - Premium: Not Pre Agreed / Endorsement Pack Approval'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / Endorsement Pack Approval'
    }
  }

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName :  summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />

      <Scrollbox>

        <BrokingSummary data={summary} />

        <ContentCard
          title={endorsmentTypeEnum[endorsmentType] ? endorsmentTypeEnum[endorsmentType].title : "SEND POLICY PACK - CLIENT"}
          icon
          info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
          filterContact
          handleFilterContact={(idContactDepartment) => listContacts(idContactDepartment)}
        >

          <Formik
            innerRef={formik}
            initialValues={{
              cc: '',
              policyPackMessage: '',
              dealAnalisysInformation: ''

            }}
            onSubmit={handleSubmit}
          >
            {formikProps => (
              <Form>
                <Row>
                  <Col>
                    <Title>TO</Title>
                    {listItems}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Field
                      style={{ marginTop: 10 }}
                      label={'CC'}
                      name={'cc'}
                      value={formikProps.values.cc}
                      onChange={(e) => formikProps?.setFieldValue('cc', e)}
                      component={InputField}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      readOnly
                      label={'Policy Pack Message - (External)'}
                      name={'policyPackMessage'}
                      disabled
                      value={formikProps.values.policyPackMessage}
                      onChange={(e) => formikProps?.setFieldValue('policyPackMessage', e)}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                {wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile
                  || wordingAttachmentFile && wordingAttachmentFile.nameFile ?
                  <Col md={9} sm={1} style={{ marginBottom: 20 }}>
                    <Label>Attachments</Label>
                    <TagsList3
                      tags={[wordingAttachmentFile, wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
                      disableType
                      hideTrash={true}
                    />
                  </Col>
                  : ''}
                <Footer>
                  <ButtonContainer>
                    <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                      <HasPermission permission={!isBound}>
                        <ButtonContent>
                          <div style={{ marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <HasPermission permission={props.permissions.POLICY_PACK_SEND_CLIENT && !endorsmentType}>
                            <Button primary type='submit' style={{ marginLeft: "10px", marginTop: "5px" }}>
                              SEND POLICY PACK
                            </Button>
                          </HasPermission>
                          <HasPermission permission={props.permissions.ENDORSEMENT_PACK_SEND_CLIENT && endorsmentType}>
                            <Button primary type='submit' style={{ marginLeft: "10px", marginTop: "5px" }}>
                              SEND ENDORS. PACK
                            </Button>
                          </HasPermission>
                        </ButtonContent>
                      </HasPermission>
                    </RenderButtons>
                  </ButtonContainer>
                </Footer>
              </Form>
            )}
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}